import styled from "styled-components";

export const ButtonContainer = styled.button`
  text-transform: capitalize;
  font-size: 1.4rem;
  background: transparent;
  border: 0.05rem solid #ffc5cb;
  border-color: ${props =>
    props.cart ? "var(--mainYellow)" : "#e2c876"};
  color: var(--lightBlue);
  color: ${props => (props.cart ? "var(--mainYellow)" : "#e2c876")};
  border-radius: 0.5rem;
  padding: 0.2rem 0.5rem;
  outline-color: #d9b74c;
  cursor: pointer;
  display: inline-block;
  margin: 0.2rem 0.5rem 0.2rem 0;
  transition: all 0.5s ease-in-out;
  &:hover {
    background: #e2c876;
    background: ${props =>
      props.cart ? "var(--mainYellow)" : "#e2c876"};
    color: black;
  }
  &:focus {
    outline: none;
  }
`;
export const ButtonContainer2 = styled.button`
  text-transform: capitalize;
  font-size: 1.4rem;
  background: transparent;
  border: 0.05rem solid #ffc5cb;
  border-color: ${props =>
    props.cart ? "var(--mainYellow)" : "#004e92"};
  color: var(--lightBlue);
  color: ${props => (props.cart ? "var(--mainYellow)" : "#004e92")};
  border-radius: 0.5rem;
  padding: 0.2rem 0.5rem;
  outline-color: #d9b74c;
  cursor: pointer;
  display: inline-block;
  margin: 0.2rem 0.5rem 0.2rem 0;
  transition: all 0.5s ease-in-out;
  &:hover {
    background: #004e92;
    background: ${props =>
      props.cart ? "var(--mainYellow)" : "#004e92"};
    color: white;
  }
  &:focus {
    outline: none;
  }
`;